import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface ViewAllButtonProps {
  onClick?: () => void;
  label?: string;
  sortType: "newest" | "popular" | "on_sale" | "featured";
  path: string;
}

const ViewAllButton: React.FC<ViewAllButtonProps> = ({
  onClick,
  label,
  sortType,
  path,
}) => {
  const getButtonStyles = () => {
    return "bg-primary hover:bg-primary-dark text-primary-foreground border border-primary hover:border-accent hover:shadow-[0_0_12px_rgba(201,169,110,0.3)] transition-shadow";
  };

  const getDefaultLabel = () => {
    switch (sortType) {
      case "on_sale":
        return "View All Sales";
      case "newest":
        return "View All New";
      case "popular":
        return "View All Popular";
      case "featured":
        return "View All Featured";
      default:
        return "View All";
    }
  };

  const buttonStyles = getButtonStyles();

  return (
    <div className="flex justify-center">
      <Link to={path} onClick={onClick} className="group">
        {/* Mobile: compact text link */}
        <span className="sm:hidden inline-flex items-center gap-1 text-sm font-medium text-accent">
          <span>{label || getDefaultLabel()}</span>
          <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" />
        </span>

        {/* Desktop: pill button */}
        <button
          className={`
            ${buttonStyles}
            hidden sm:inline-flex
            px-5 py-2.5 rounded-lg font-medium text-sm
            transition-all duration-200
            shadow-sm hover:shadow-md
            transform hover:-translate-y-0.5
            active:translate-y-0
            items-center gap-2
          `}
        >
          <span className="flex items-center gap-1.5">
            <span>{label || getDefaultLabel()}</span>
            <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" />
          </span>
        </button>
      </Link>
    </div>
  );
};

export default ViewAllButton;
